import { IAgencyFormData, IAgencyFormDataErrors } from "agency/model"
import { translate } from "app/language/service"
import { COUNTRIES_WITCH_REQUIRE_STATE } from "user/model"

export function validateAgencyFormData(data: IAgencyFormData): IAgencyFormDataErrors {
  const errors: IAgencyFormDataErrors = {}
  if (!data.name) {
    errors.name = translate("label.field.required")
  }
  if (!data.currency_id) {
    errors.currency_id = translate("label.field.required")
  }
  if (!data.country) {
    errors.country = translate("label.field.required")
  } else if (COUNTRIES_WITCH_REQUIRE_STATE.includes(data.country) && !data.state) {
    errors.state = translate("label.field.required")
  }
  return errors
}
